import { SORTING_DIRECTION } from '~/constants/main';
import { IResponseReportBody } from '~/types/reports';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';

export interface IReportRow {
  name: string;
  body: IResponseReportBody;
}

export enum REPORTS_BODY_KEY {
  ORDERS_COUNT = 'orders_count',
  REVENUE = 'revenue',
  AVERAGE_CHECK = 'average_check',
  PICKUP_COUNT = 'pickup_count',
  PICKUP_REVENUE = 'pickup_revenue',
  DELIVERY_COUNT = 'delivery_count',
  DELIVERY_REVENUE = 'delivery_revenue',
  DINEIN_COUNT = 'dinein_count',
  DINEIN_REVENUE = 'dinein_revenue',

  // item sales report
  ITEMS_COUNT = 'items_count',
  PICKUP_ITEMS_COUNT = 'pickup_items_count',
  DELIVERY_ITEMS_COUNT = 'delivery_items_count',
  DINEIN_ITEMS_COUNT = 'dinein_items_count',

  //combo sales report
  TOTAL_NUMBER_OF_COMBO = 'combo_count',
  PICKUP_NUMBER_OF_COMBO = 'pickup_combo_count',
  DELIVERY_NUMBER_OF_COMBO = 'delivery_combo_count',
  DINEIN_NUMBER_OF_COMBO = 'dinein_combo_count',
  TOTAL_COMBO_PRICE = 'combo_price',
}

export enum REPORT_TYPE {
  ITEMS = 'ITEMS',
  COMBO = 'COMBO',
  DEFAULT = 'DEFAULT',
}

export interface IReportsFilters {
  startDate: number;
  endDate: number;
  branches: IPickerOption[];
  franchisee?: IPickerOption[];
  franchisee_branches: IPickerOption[];
  sortField: REPORTS_BODY_KEY | undefined;
  sortDir: SORTING_DIRECTION | undefined;
}

export interface IReportsParams {
  from: string;
  to: string;
  branches: number[];
  franchisee_id?: number | string;
}
